import React from 'react'
import { UploadCsv } from './uploadCsv'
import { DiscountType } from '../_shared'
import { ModalBody } from 'uiComponents/popups/modal.new'
import { OptionTile } from 'uiComponents/optionTile'
import { useTranslation } from 'translations'

interface ChooseDiscountTypeProps {
    onSelectDiscountType: (discountType: DiscountType) => void
}

export const ChooseDiscountType = ({ onSelectDiscountType }: ChooseDiscountTypeProps) => {
    const { t } = useTranslation()

    return (
    <ModalBody>
        <OptionTile
            title={t('discounts.addDiscount.cartTitle')}
            description={t('discounts.addDiscount.cartDescription')}
            icon="ShoppingCart"
            onClick={() => onSelectDiscountType('cart')}
        />
        <OptionTile
            title={t('discounts.addDiscount.productTitle')}
            description={t('discounts.addDiscount.productDescription')}
            icon="Tag"
            onClick={() => onSelectDiscountType('product')}
        />
        <UploadCsv />
    </ModalBody>
    )
}
